import { Button } from "@babackapp/customer-ui/components/button";
import {
  Article,
  ArticleAction,
  ArticleImage,
  ArticleList,
  ArticleTitle,
} from "@babackapp/customer-ui/components/article";
import { OptionContent } from "@babackapp/customer-ui/components/option";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import { useSetRebuyItems } from "@babackapp/return-widget-components/hooks/use-set-rebuy-items";
import type { CartItem } from "@babackapp/return-widget-components/types";
import { PlusIcon, Trash2Icon } from "lucide-react";
import { useState } from "react";
import { CatalogPickerDialog } from "./catalog-picker/catalog-picker-dialog";

type Props = {
  shopId: string;
  orderId: string;
};

export function CatalogPickerFooter({ shopId, orderId }: Props) {
  const t = useCustomText();
  const draft = useDraftReturn(orderId);
  const setRebuyItems = useSetRebuyItems(orderId);
  const items = draft?.rebuyItems ?? [];
  const [open, setOpen] = useState(false);

  function handleConfirm(item: CartItem) {
    setRebuyItems([...items, item]);
  }

  function handleRemove(index: number) {
    setRebuyItems(items.filter((_, i) => i !== index));
  }

  return (
    <OptionContent>
      <div className="flex w-full flex-col gap-3">
        {items.length > 0 && (
          <ArticleList>
            {items.map((item, i) => (
              <Article key={`${item.variantId}-${i}`}>
                {item.image && <ArticleImage src={item.image} layoutId={`img-opt-${i}`} />}
                <ArticleTitle>{item.title}</ArticleTitle>
                <ArticleAction autoHide={false}>
                  <Button
                    variant="outline"
                    size="icon-sm"
                    onClick={() => handleRemove(i)}
                  >
                    <Trash2Icon />
                  </Button>
                </ArticleAction>
              </Article>
            ))}
          </ArticleList>
        )}

        <Button
          type="button"
          variant="secondary"
          className="w-full"
          onClick={() => setOpen(true)}
        >
          <PlusIcon />
          {items.length > 0 ? t("catalogPicker.addAnother") : t("catalogPicker.trigger")}
        </Button>
      </div>

      <CatalogPickerDialog
        shopId={shopId}
        open={open}
        onOpenChange={setOpen}
        onConfirm={handleConfirm}
      />
    </OptionContent>
  );
}
